import { useRef, useState } from 'react';
import SizeBoxes from '../SizeBoxes/SizeBoxes';
import {
  SizeandPackSec,
  SizeChartButton,
  SizeHeading,
  SizeSubHeading,
} from './styled';
import { maternitySkusList } from '../../Product/OfferCarousel/constant';

export default function SizeandPacks(props) {
  const {
    varientData,
    clickProductColorHandler,
    productDetail,
    selectedData,
    setShowSizeChartPopup,
    showNewLandingPageUI,
    showNewDiaperVariantUx,
    isVariantPopup,
    showNewLactomamaVariantUx,
    setUpdateVariant,
    updateVariant,
    setUserSelectedVariant,
    setSelectedVariant,
    packsCount,
    generalItemsDataByFlavour,
    flavourTitles,
    setGeneralItems,
    setTabThemeColor,
    setTabThemeSecondaryColor,
    tabThemeColor
  } = props;
  const sizePack = useRef(null);
  // const CenterPopup = CenterStylePopup("50%", "auto", "auto", "50%");
  // const closeModal = () => {
  //     setSizePopupOpen(false);
  // };
  const [gesture, setGesture] = useState(false);
  const clickFeedback = () => {
    setGesture(true);
    setTimeout(() => {
      setShowSizeChartPopup(true);
      setGesture(false);
    }, 120);
  };
  const sizeChartHandler = () => {
    setSizePopupOpen(true);
    fireEvent({
      category: 'clicked_cta',
      product_id: productDetail?.id || 'NA',
      product_name: productDetail?.name,
      cta: 'size_chart',
      cta_type: 'primary',
      parent: 'size_chart',
    });
  };

  const isMaternitySku = maternitySkusList.includes(
    parseInt(productDetail?.id),
  );

  return (
    !isVariantPopup && (
      <SizeandPackSec ref={sizePack}>
        <SizeHeading isMaternitySku={isMaternitySku}>
          <SizeSubHeading
            showNewDiaperVariantUx={showNewDiaperVariantUx}
            showNewLactomamaVariantUx={showNewLactomamaVariantUx}
          >
            {showNewLactomamaVariantUx &&
            varientData?.variant_type.toLowerCase() == 'flavour' ? (
              <div className="sizeSelectHeadNew">
                <p className="titleNew">Select Flavour :  {selectedData[varientData?.variant_type?.toUpperCase()] && 
      <span style={{ color: props.tabThemeColor || '#498A5B', fontWeight: 'bold' }}>
        {` ${selectedData[varientData?.variant_type?.toUpperCase()]}`}
      </span>
    
      }</p>
              </div>
            ) : showNewDiaperVariantUx ? (
              varientData?.variant_type.toLowerCase() == 'size' ? (
                <div className="sizeSelectHeadNew">
                  <p className="titleNew">Select Size</p>
                  <SizeChartButton
                    style={{
                      textDecoration: 'underline',
                      color: '#000',
                    }}
                    onClick={() => {
                      clickFeedback();
                    }}
                  >
                    Size Chart
                  </SizeChartButton>
                </div>
              ) : null
            ) : showNewLandingPageUI ? (
              <p className="titleNew">
                {varientData?.variant_type.toLowerCase() == 'size' ? (
                  `Size: ${
                    selectedData[varientData?.variant_type?.toUpperCase()]
                  }`
                ) : (
                  <p className="titleNew">{`Unit Count: ${
                    selectedData[
                      varientData?.variant_type?.toUpperCase()
                    ]?.split(' of ')[1]
                  }`}</p>
                )}
              </p>
            ) : (
              <>{varientData?.variant_type.toUpperCase()} : &nbsp;</>
            )}
          </SizeSubHeading>
          {varientData?.sizeChart && !showNewDiaperVariantUx ? (
            <SizeChartButton
              style={{ opacity: gesture ? 0.4 : 1 }}
              onClick={() => {
                clickFeedback();
              }}
            >
              Size Chart
            </SizeChartButton>
          ) : null}
        </SizeHeading>
        <SizeBoxes
          clickProductColorHandler={clickProductColorHandler}
          varientData={varientData?.data}
          varientTitle={varientData?.variant_type}
          productDetail={productDetail}
          selectedSize={selectedData[varientData?.variant_type?.toUpperCase()]}
          selectedData={selectedData}
          showNewLandingPageUI={showNewLandingPageUI}
          showNewDiaperVariantUx={showNewDiaperVariantUx}
          showNewLactomamaVariantUx={showNewLactomamaVariantUx}
          setUpdateVariant={setUpdateVariant}
          updateVariant={updateVariant}
          setUserSelectedVariant={setUserSelectedVariant}
          setSelectedVariant={setSelectedVariant}
          packsCount={packsCount}
          generalItemsDataByFlavour={generalItemsDataByFlavour}
          flavourTitles={flavourTitles}
          setGeneralItems={setGeneralItems}
          setTabThemeColor={setTabThemeColor}
          setTabThemeSecondaryColor={setTabThemeSecondaryColor}
        />
      </SizeandPackSec>
    )
  );
}

